import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { orderimg1 } from "../../constants";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/refund-order.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Refund_Order = () => {
	useEffect(() => {
		let input = document.getElementById("inputTag");
		let imageName = document.getElementById("imageName");

		input.addEventListener("change", () => {
			let inputImage = document.querySelector("input[type=file]").files[0];

			imageName.innerText = inputImage.name;
		});
	}, []);
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* refund order starts here */}
							<div className="refund-order-wrapper">
								<div className="heading-wrapper">
									<h4>Refund Order</h4>
								</div>
								<div className="refund-fill-form-wrapper">
									<div className="heading-wrapper">
										<h5>Fill The Refund Form</h5>
									</div>
									<div className="refund-product-form-wrapper">
										<div className="refund-product-wrapper">
											<div className="product-head-wrapper">
												<h5>Products</h5>
											</div>
											<div className="product-refund-wrapper">
												<div className="img-wrapper">
													<figure>
														<img src={orderimg1} className="img-fluid" alt="" />
													</figure>
												</div>
												<div className="refund-content-wrapper">
													<div className="head-date-wrapper">
														<h5>Sweet Black Shirt </h5>
														<h6>Delivery Date</h6>
													</div>
													<div className="size-wrapper">
														<div className="size-ql-wrapper">
															<ul>
																<li>Size L</li>
																<li>Quantity 2</li>
															</ul>
														</div>
														<div className="size-date-wrapper">
															<span>10/11/22</span>
														</div>
													</div>
													<div className="price-wrapper">
														<h5>RS : $22.00</h5>
													</div>
												</div>
											</div>
											<div className="refund-form-wrapper">
												<form action="">
													<div className="form-group">
														<label htmlFor="">Return Reason</label>
														<select name="" className="form-control" id="">
															<option value="Select Return Reason" selected>
																Select Return Reason
															</option>
														</select>
													</div>
													<div className="form-group">
														<label htmlFor="">Upload Picture</label>
														<label className="tag" htmlFor="inputTag">
															<div className="fiel-wrapper">
																<span>Add Product Image</span>
																<i className="fa fa-paperclip"></i>
															</div>
															<input
																id="inputTag"
																type="file"
																name=""
																className="form-comtrol"
															/>
															<span id="imageName"></span>
														</label>
													</div>
													<div className="form-group">
														<label htmlFor="">Comment</label>
														<textarea
															name=""
															className="form-control"
															id=""
															cols="30"
															rows="10"
															placeholder="Type Your Issue"
														></textarea>
													</div>
													<div className="form-group">
														<button type="submit" className="btn">
															Confirm Refund Order
														</button>
													</div>
												</form>
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* refund order ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Refund_Order;
